import React, { useEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import PayrollList from './PayrollList';
import styles from '../../styles/payrollRegister.module.css';

export function PayrollRegister(props) {

    const handleTitle = () => {
        if (props.onLoadTitle != null) {
            props.onLoadTitle(i18next.t('menu:payrollRegister'));
        }
    }

    const resizePage = () => {
        setTimeout(() => {
            const heightWindow = window.innerHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 0;
            const customHeight = heightWindow - menu - offSet;

            const element = document.querySelector("#divPayrollList");
            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 250);
    }

    useEffect(() => {
        handleTitle();
        resizePage();
    }, []);

    return (
        <div id="divPayrollList" className={styles.konekCard} style={{ zIndex: '1'}}>
            <PayrollList/>
        </div>
    );
}

export default withNamespaces(['menu', 'payrollRegister', 'common', 'error'], { wait: true })(PayrollRegister);